"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FollowUser = void 0;
var config = require("../../../config/web");
var hex_md5 = require('../md5');
var cookie_1 = __importDefault(require("../cookie"));
/**
 * 获取股吧jsonp接口参数
 */
function getGubaJsonParam(uid) {
    var token = "ctoken=" + cookie_1.default.get('ct') + "utoken=" + cookie_1.default.get('ut') + "_519d77b29be442f8";
    var result = "version=100&product=CFH&plat=Web&h=".concat(hex_md5(token), "&deviceid=").concat(hex_md5(uid));
    return result;
}
function FollowUser(hasFollow, id) {
    return __awaiter(this, void 0, void 0, function () {
        var gb_params, json, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    gb_params = getGubaJsonParam(id);
                    return [4 /*yield*/, $.ajax({
                            url: "".concat(config.getWebPath("guba"), "followopt/api/Follow/").concat(hasFollow ? "CancelFollowUser4Jsonp" : "FollowUser4Jsonp", "?").concat(gb_params),
                            type: 'GET',
                            data: {
                                followuid: id,
                                location: "WEB|video|videolist|TRUE|\"\""
                            },
                            dataType: 'jsonp',
                            jsonpCallback: "cb" + parseInt(Math.random() * 10000 + "")
                        })];
                case 1:
                    json = _a.sent();
                    return [2 /*return*/, json];
                case 2:
                    error_1 = _a.sent();
                    return [2 /*return*/, {}];
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.FollowUser = FollowUser;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoid2ViX2diLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsid2ViX2diLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLElBQUksTUFBTSxHQUFHLE9BQU8sQ0FBQyxxQkFBcUIsQ0FBQyxDQUFBO0FBQzNDLElBQUksT0FBTyxHQUFHLE9BQU8sQ0FBQyxRQUFRLENBQUMsQ0FBQTtBQUUvQixxREFBK0I7QUFFL0I7O0dBRUc7QUFDSCxTQUFTLGdCQUFnQixDQUFDLEdBQVc7SUFDbkMsSUFBSSxLQUFLLEdBQVcsU0FBUyxHQUFHLGdCQUFNLENBQUMsR0FBRyxDQUFDLElBQUksQ0FBQyxHQUFHLFNBQVMsR0FBRyxnQkFBTSxDQUFDLEdBQUcsQ0FBQyxJQUFJLENBQUMsR0FBRyxtQkFBbUIsQ0FBQztJQUN0RyxJQUFJLE1BQU0sR0FBVyw2Q0FBc0MsT0FBTyxDQUFDLEtBQUssQ0FBQyx1QkFBYSxPQUFPLENBQUMsR0FBRyxDQUFDLENBQUUsQ0FBQztJQUNyRyxPQUFPLE1BQU0sQ0FBQztBQUNoQixDQUFDO0FBR0QsU0FBc0IsVUFBVSxDQUFDLFNBQWtCLEVBQUUsRUFBVTs7Ozs7OztvQkFHdkQsU0FBUyxHQUFHLGdCQUFnQixDQUFDLEVBQUUsQ0FBQyxDQUFDO29CQUUxQixxQkFBTSxDQUFDLENBQUMsSUFBSSxDQUFDOzRCQUN0QixHQUFHLEVBQUUsVUFBRyxNQUFNLENBQUMsVUFBVSxDQUFDLE1BQU0sQ0FBQyxrQ0FBd0IsU0FBUyxDQUFDLENBQUMsQ0FBQyx3QkFBd0IsQ0FBQyxDQUFDLENBQUMsa0JBQWtCLGNBQUksU0FBUyxDQUFFOzRCQUNqSSxJQUFJLEVBQUUsS0FBSzs0QkFDWCxJQUFJLEVBQUU7Z0NBQ0osU0FBUyxFQUFFLEVBQUU7Z0NBQ2IsUUFBUSxFQUFFLCtCQUE2Qjs2QkFDeEM7NEJBQ0QsUUFBUSxFQUFFLE9BQU87NEJBQ2pCLGFBQWEsRUFBRSxJQUFJLEdBQUcsUUFBUSxDQUFDLElBQUksQ0FBQyxNQUFNLEVBQUUsR0FBRyxLQUFLLEdBQUcsRUFBRSxDQUFDO3lCQUMzRCxDQUFDLEVBQUE7O29CQVRFLElBQUksR0FBRyxTQVNUO29CQUVGLHNCQUFPLElBQUksRUFBQTs7O29CQUdYLHNCQUFPLEVBQUUsRUFBQTs7Ozs7Q0FFWjtBQXJCRCxnQ0FxQkMifQ==